import { IconProps } from "@/src/sb/business-layer/types"

/**
 * The right arrow from Stears Platform 5.0 (Figma node 146:4767).
 *
 * Deliberately separate from `ArrowRight`: this one has a 1px shaft that runs
 * almost the full width of its 16x16 box, where `ArrowRight` has a 0.75px
 * shaft and a shorter tail in a 17x18 box.
 */
const ArrowRightSmall = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3L8.3 3.7L12.05 7.5H1.5V8.5H12.05L8.3 12.3L9 13L14 8L9 3Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowRightSmall
